import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
var initialState = { scrollPosition: {} };
export default function scrollContainerReducer(state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.SET_SCROLL_CONTAINER_SCROLL: {
            var id = action.id, coords = action.coords;
            return update(state, {
                scrollPosition: {
                    $merge: (_a = {}, _a[id] = coords, _a),
                },
            });
        }
        case actionTypes.LOCATION_CHANGED:
        case actionTypes.SET_SCROLL_CONTAINER_POSITION:
            if (action.scrollPositions) {
                return update(state, {
                    scrollPosition: { $set: action.scrollPositions },
                });
            }
            return state;
        default:
            return state;
    }
}
